import styled from "styled-components";
import {DialogActions, DialogContent} from "@material-ui/core";

interface STDialogActionProps {
    padding?: number;
}

export const STDialogActions = styled(DialogActions)`
    padding: ${({padding} : STDialogActionProps) => padding ?? 16}px !important;
`;

interface STDialogContentProps {
    paddingBottom?: number;
}

export const STDialogContent = styled(DialogContent)`
    padding-bottom: ${(props: STDialogContentProps) => props.paddingBottom ?? 32}px !important;
`;